import * as React from "react";
import { useEffect, useState } from "react";
import {
  Grid,
  Box,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  Chip,
  Divider,
  InputAdornment,
  IconButton,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { GLOBAL_URL, getRequestGlobal } from "../../../API/global";
import { postRequest, getRequest } from "../../../API/IP";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { convertDate, validateFileall } from "../../Helper";
import Loader from "../../common/Loader/Loader";
const FilmsDetails = ({
  formData,
  setFormData,
  errors,
  setFilmDetailsErrors,
}) => {
  const [selectedUploadCV, setSelectedUploadCV] = useState(null);
  const [selectedUploadReel, setSelectedUploadReel] = useState(null);
  const [craftData, setCraftData] = useState([]);
  const [specializationData, setSpecializationData] = useState([]);
  const [showSpecializtion, setShowSpecializtion] = useState([]);
  const [changeCraftName, setChangeCraftName] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleTimeChange = (newValue) => {
    if (!newValue) {
      setFormData((prevData) => ({
        ...prevData,
        film_duration: "",
      }));
      setFilmDetailsErrors((prevErrors) => ({
        ...prevErrors,
        film_duration: "Film duration must be provided",
      }));
      return;
    }

    // Extract minutes and seconds from the dayjs object
    const minutes = newValue.minute();
    const seconds = newValue.second();

    // Format duration as "mm:ss" string
    const formattedDuration = `${minutes}:${seconds
      .toString()
      .padStart(2, "0")}`;

    // Update form data with formatted duration
    setFormData((prevData) => ({
      ...prevData,
      film_duration: formattedDuration,
    }));

    // Validate duration
    const durationInMinutes = minutes + seconds / 60;
    if (
      isNaN(durationInMinutes) ||
      durationInMinutes < 1 ||
      durationInMinutes > 10
    ) {
      setFilmDetailsErrors((prevErrors) => ({
        ...prevErrors,
        film_duration: "Film duration must be between 1 and 10 minutes",
      }));
    } else {
      setFilmDetailsErrors((prevErrors) => ({
        ...prevErrors,
        film_duration: "",
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    errors[name] = "";
    setFilmDetailsErrors(errors);
    if (name === "film_duration") {
      const duration = parseFloat(value);
      if (isNaN(duration) || duration < 1 || duration > 10) {
        setFilmDetailsErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Film duration must be between 1 and 10 minutes",
        }));
      } else {
        setFilmDetailsErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      }
    }
  };

  const handleChangeDateOfCompletion = (e) => {
    if (e) {
      const formattedDate = e.format("DD/MM/YYYY");
      const convertedDate = convertDate(e.toDate());
      setFormData((prevData) => ({
        ...prevData,
        project_completion_date: convertedDate,
      }));
      // console.log('formattedDate', formattedDate);

      // Clear the error message only if a valid date is selected
      setFilmDetailsErrors((prevErrors) => ({
        ...prevErrors,
        project_completion_date: "",
      }));
    }
  };

  const Root = styled("div")(({ theme }) => ({
    width: "100%",
    margin: "10px",
    color: theme.palette.text.secondary,
    "& > :not(style) ~ :not(style)": {
      marginTop: theme.spacing(2),
    },
  }));

  const handleSelectedUploadCV = (event) => {
    const selectedFile = event.target.files[0];
    setSelectedUploadCV(selectedFile);

    const validateFirstID = validateFileall(selectedFile);

    if (!validateFirstID["status"]) {
      setFilmDetailsErrors((prevErrors) => ({
        ...prevErrors,
        is_upload_cv: validateFirstID.message,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        upload_cv: selectedFile, // assuming you want to save the file itself
        is_upload_cv: 1,
      }));

      // Clear the error message for the 'upload_cv' field
      setFilmDetailsErrors((prevErrors) => ({
        ...prevErrors,
        is_upload_cv: "",
      }));
    }
  };

  const handleSelectedUploadReel = (event) => {
    const file = event.target.files[0];

    if (file) {
      setIsLoading(true); // Start loading

      const maxSize = 100 * 1024 * 1024; // 100 MB in bytes
      if (file.size > maxSize) {
        setFilmDetailsErrors((prevErrors) => ({
          ...prevErrors,
          is_upload_reel: "Video size exceeds 100 MB",
        }));
        event.target.value = "";
        setIsLoading(false); // Stop loading if error
      } else {
        setSelectedUploadReel(file);
        setFormData((prevState) => ({
          ...prevState,
          upload_reel: file,
          is_upload_reel: 1,
        }));

        // Clear the error message since the file size is valid
        setFilmDetailsErrors((prevErrors) => ({
          ...prevErrors,
          is_upload_reel: "",
        }));

        // Simulate a delay for upload (e.g., you could use an actual upload API here)
        setTimeout(() => {
          setIsLoading(false); // Stop loading after the file is "uploaded"
        }, 1000); // 1000ms delay for demonstration
      }
    } else {
      setFilmDetailsErrors((prevErrors) => ({
        ...prevErrors,
        is_upload_reel: "No file selected", // Optional: handle no file selected case
      }));
      setIsLoading(false); // Stop loading if no file is selected
    }
  };

  const loadpreData = async () => {
    const data = {};
    const specializationdata = {};
    const showSpecializtion = {};
    // const showCraftname = {}
    const changeCraftName = {};
    try {
      const predata = await getRequest(`craft`, {});
      if (predata.status && predata.data.length) {
        for (const craft of predata.data) {
          data[craft.id] = craft.name;
          showSpecializtion[craft.id] = craft.specialization;
          changeCraftName[craft.id] = craft.type;
        }
        setCraftData(data);
        setShowSpecializtion(showSpecializtion); //setshowSpecializtion
        setChangeCraftName(changeCraftName); //setChangeCraftName
      }
      const predataSpecialization = await getRequest(
        `craft/specialization`,
        {}
      );
      if (predataSpecialization.status && predataSpecialization.data.length) {
        for (const craft of predataSpecialization.data) {
          specializationdata[craft.id] = craft.name;
        }
        setSpecializationData(specializationdata);
      }
    } catch (error) {}
  };

  useEffect(() => {
    loadpreData();
  }, []);
  const minTime = dayjs().startOf("day");
  const maxTime = dayjs().startOf("day").add(10, "minute");
  return (
    <>
      {isLoading && <Loader />}
      <div className="cmot-phone">
        <h5>STEP 3</h5>
        <p>
          Films Details <span className="text-danger">*</span>
        </p>
      </div>
      <form>
        <Grid container spacing={2} className="mt-3">
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box>
              <TextField
                id="category_id"
                fullWidth
                label="Film Craft"
                select
                value={formData.category_id || ""}
                onChange={handleChange}
                error={!!errors.category_id}
                helperText={errors.category_id}
                variant="outlined"
                name="category_id"
              >
                {Object.entries(craftData).map(([key, value]) => (
                  <MenuItem key={key} value={key}>
                    {value}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>
          {showSpecializtion[formData.category_id] ? (
            <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
              <Box>
                <TextField
                  id="specialization"
                  fullWidth
                  label="Specialisation (2D/3D/Rigging/Texturing/Other)"
                  type="text"
                  value={formData.specialization || ""}
                  onChange={handleChange}
                  error={!!errors.specialization}
                  helperText={errors.specialization}
                  variant="outlined"
                  name="specialization"
                />
              </Box>
            </Grid>
          ) : (
            <></>
          )}

          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Link to your Submission"
                type="text"
                fullWidth
                name="link_of_film"
                value={formData.link_of_film}
                onChange={handleChange}
                error={!!errors.link_of_film}
                helperText={errors.link_of_film}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Password"
                type="text"
                fullWidth
                name="link_film_password"
                value={formData.link_film_password}
                onChange={handleChange}
                error={!!errors.link_film_password}
                helperText={errors.link_film_password}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Project Title (Film/Audio Track/Portfolio)*"
                type="text"
                fullWidth
                name="project_title"
                value={formData.project_title}
                onChange={handleChange}
                error={!!errors.project_title}
                helperText={errors.project_title}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Duration (Minutes and Seconds)"
                  value={
                    formData.film_duration
                      ? dayjs(`2000-01-01T00:${formData.film_duration}:00`)
                      : null
                  }
                  onChange={handleTimeChange}
                  views={["minutes", "seconds"]}
                  inputFormat="mm:ss"
                  ampm={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root": {
                          fontSize: {
                            xs: "0.9rem", // slightly smaller font for mobile
                            sm: "1rem",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: {
                            xs: "0.85rem",
                            sm: "1rem",
                          },
                        },
                      }}
                    />
                  )}
                  sx={{
                    width: "100%",
                    "& .MuiDialog-paper": {
                      width: "90% !important",
                      maxWidth: "350px !important",
                      m: "auto",
                    },
                  }}
                  minTime={minTime}
                  maxTime={maxTime}
                  minutesStep={1}
                  // disableOpenPicker={true}
                />
                {errors.film_duration && (
                  <div style={{ color: "red" }}>{errors.film_duration}</div>
                )}
              </LocalizationProvider>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box sx={{ width: "100%" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Project Completion Date"
                  placeholder="Project Completion Date"
                  name="project_completion_date"
                  value={dayjs(formData.project_completion_date, "YYYY-MM-DD")}
                  onChange={handleChangeDateOfCompletion}
                  format="DD/MM/YYYY"
                  placeholderText="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                  slotProps={{
                    textField: {
                      InputProps: { readOnly: true },
                      readOnly: true,
                      error: false,
                    },
                  }}
                />

                {errors.project_completion_date && (
                  <div style={{ color: "red" }}>
                    {errors.project_completion_date}
                  </div>
                )}
              </LocalizationProvider>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box>
              <input
                type="file"
                // accept=".doc,.docx,.pdf,.jpg,.jpeg,.png"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleSelectedUploadCV}
                style={{ display: "none", width: "100%" }}
                id="selectedUploadCV"
                name="upload_cv"
              />
              <label
                htmlFor="selectedUploadCV"
                style={{ width: "100%", height: "100%" }}
              >
                <TextField
                  variant="outlined"
                  placeholder="Upload CV"
                  value={selectedUploadCV ? selectedUploadCV.name : ""}
                  error={!!errors.is_upload_cv}
                  helperText={errors.is_upload_cv}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            document.getElementById("selectedUploadCV").click()
                          }
                          edge="end"
                        >
                          <AttachFileIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
                {formData?.documentData?.[3] && (
                  <div>
                    <span className="Attach_Photo_ID">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[3].file}`}
                      >
                        {formData?.documentData?.[3].name}
                      </a>
                    </span>
                  </div>
                )}
              </label>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box style={{ width: "100%", height: "100%" }}>
              <TextField
                variant="outlined"
                label="Enter Filmography URL"
                type="text"
                fullWidth
                name="filmography_url"
                value={formData.filmography_url}
                onChange={handleChange}
                error={!!errors.filmography_url}
                helperText={errors.filmography_url}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className="p-1">
            <Box>
              <input
                type="file"
                accept=".mp4,.avi,.mov,.mkv"
                onChange={handleSelectedUploadReel}
                style={{ display: "none", width: "100%" }}
                id="selectedUploadReel"
                name="upload_reel"
              />
              <label
                htmlFor="selectedUploadReel"
                style={{ width: "100%", height: "100%" }}
              >
                <TextField
                  variant="outlined"
                  placeholder="Upload Showreel Video up to 100MB"
                  value={selectedUploadReel ? selectedUploadReel.name : ""}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            document
                              .getElementById("selectedUploadReel")
                              .click()
                          }
                          edge="end"
                        >
                          <AttachFileIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.is_upload_reel}
                  helperText={errors.is_upload_reel}
                  fullWidth
                />
                {formData?.documentData?.[4] && (
                  <div>
                    <span className="Attach_Photo_ID">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[4].file}`}
                      >
                        {formData?.documentData?.[4].name}
                      </a>
                    </span>
                  </div>
                )}
              </label>
            </Box>
          </Grid>
          <Root>
            <Divider>
              <Chip label="Optional" size="small" />
            </Divider>
          </Root>
          <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
            <Box>
              <TextField
                variant="outlined"
                label="Awards/Recognition (If Any)"
                type="text"
                fullWidth
                multiline
                name="awards_recognition"
                value={formData.awards_recognition}
                onChange={handleChange}
              />
            </Box>
            {errors.awards_recognition && (
              <p className="text-danger">{errors.awards_recognition}</p>
            )}
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default FilmsDetails;
